import type { RenderElementProps } from 'slate-react'

export default function TableRow({ attributes, children }: RenderElementProps) {
  return <tr {...attributes}>{children}</tr>
}
